const xeDesignSystemVisuals = [
  {
    src: "/images/xe/design-system/01-welcome.webp",
    alt: "XE design system welcome and documentation overview",
    caption: "Design system welcome",
  },
  {
    src: "/images/xe/design-system/03-welcome-strategy.webp",
    alt: "XE design system strategy and guiding principles",
    caption: "System strategy",
  },
  {
    src: "/images/xe/design-system/04-consumer-logo.webp",
    alt: "XE consumer brand logo guidance",
    caption: "Consumer logo guidance",
  },
  {
    src: "/images/xe/design-system/06-consumer-colours.webp",
    alt: "XE consumer colour foundations and palette",
    caption: "Consumer colour foundations",
  },
  {
    src: "/images/xe/design-system/10-consumer-icon-style.webp",
    alt: "XE consumer icon style guidance",
    caption: "Icon style",
  },
  {
    src: "/images/xe/design-system/12-consumer-applications.webp",
    alt: "XE consumer brand applied across digital experiences",
    caption: "Consumer applications",
  },
  {
    src: "/images/xe/design-system/13-consumer-web-breakpoints-grids.webp",
    alt: "XE consumer responsive breakpoints and grid guidance",
    caption: "Responsive grids",
  },
  {
    src: "/images/xe/design-system/14-consumer-web-buttons.webp",
    alt: "XE consumer button components and states",
    caption: "Button patterns",
  },
  {
    src: "/images/xe/design-system/15-consumer-web-typography.webp",
    alt: "XE consumer web typography guidance",
    caption: "Web typography",
  },
  {
    src: "/images/xe/design-system/18-consumer-web-forms.webp",
    alt: "XE consumer form components and interaction guidance",
    caption: "Form patterns",
  },
  {
    src: "/images/xe/design-system/27-corporate-applications.webp",
    alt: "XE corporate brand applied across digital experiences",
    caption: "Corporate applications",
  },
  {
    src: "/images/xe/design-system/28-corporate-web-breakpoints-grids.webp",
    alt: "XE corporate responsive breakpoints and grid guidance",
    caption: "Corporate responsive grids",
  },
  {
    src: "/images/xe/design-system/29-corporate-web-buttons.webp",
    alt: "XE corporate button components and states",
    caption: "Corporate button patterns",
  },
  {
    src: "/images/xe/design-system/34-tone-writing-xe.webp",
    alt: "XE tone of voice and writing guidance",
    caption: "Writing for XE",
  },
  {
    src: "/images/xe/design-system/42-accessibility.webp",
    alt: "XE accessibility principles and guidance",
    caption: "Accessibility guidance",
  },
  {
    src: "/images/xe/design-system/43-icons.webp",
    alt: "XE icon library and usage guidance",
    caption: "Shared icon library",
  },
];

export default xeDesignSystemVisuals;
